import { CcfBox, CcfTypography, useTranslator } from '@nice-ccf/ui-controls';
import styles from './voice-transcription-flow.module.scss';
import React from 'react';
import { ArrowDropDown } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { activeContactSelector } from 'libs/react/ui-components/src/lib/ccf-inbox/ccf-inbox.slice';

/* eslint-disable-next-line */
export interface VoiceTranscriptionFlowProps {
  interaction: any;
}

/**
 * VoiceTranscriptionFlow - rused to display Voice Transcript in Interaction Tab Details View
 * @param props - VoiceTranscriptionFlowProps
 * @returns - appspace
 * @example - `<VoiceTranscriptionFlow />`
 */
export function VoiceTranscriptionFlow(props: VoiceTranscriptionFlowProps) {
  const { interaction } = props;
  const [translate] = useTranslator();
  const activeContact = useSelector(activeContactSelector);
  const customerName = `${activeContact?.customer.firstName} ${activeContact?.customer.lastName}`;
  const VoiceTranscriptData = [
    {
      speaker: interaction.agentName,
      timeInterval: '00:03',
      transcript: `Hello, is this ${activeContact?.customer.salutation} ${customerName} `,
    },
    {
      speaker: customerName,
      timeInterval: '00:05',
      transcript: `Yes this is ${customerName}`,
    },
    {
      speaker: customerName,
      timeInterval: '00:05',
      transcript: `Yes this is ${customerName}`,
    },
    {
      speaker: customerName,
      timeInterval: '00:05',
      transcript: `Yes this is ${customerName}`,
    },
  ];
  return (
    <CcfBox className={styles.voiceTranscriptionContainer}>
      <CcfTypography className={styles.title} translationKey={'Transcription'}></CcfTypography>
      <CcfBox className={styles.voiceTranscriptionBlock}>
        {VoiceTranscriptData.map((transcript, index) => (
          <CcfBox className={styles.transcript} key={index}>
            <CcfBox className={styles.header}>
              <CcfBox className={styles.speakerRow}>
                <CcfTypography className={styles.text}>
                  {transcript.speaker}
                </CcfTypography>
                <ArrowDropDown />
              </CcfBox>
              <CcfBox>
                <CcfTypography className={styles.text}>
                  {transcript.timeInterval}
                </CcfTypography>
              </CcfBox>
            </CcfBox>

            <CcfBox>
              <CcfTypography className={styles.text}>
                {transcript.transcript}
              </CcfTypography>
            </CcfBox>
          </CcfBox>
        ))}
      </CcfBox>
      <CcfBox className={styles.horizontalLineWithText}>
        <span>{translate('endOfTranscription')}</span>
      </CcfBox>
    </CcfBox>
  );
}

export default VoiceTranscriptionFlow;
